<div class="shipping_form">
  @if (listRate.meta === "error") {
    <p>{{ listRate.error.message }}</p>
  } @else {
    @for (item of listRate.data; track $index) {
      <div class="form-check">
        <label class="form-check-label">
          <input type="radio" class="form-check-input" [value]="item.service" (change)="selectRate(item.service)" />
          <fa-icon [icon]="iconFedex" size="2x"></fa-icon>
          <span class="dateShipping">{{ item.deliveryEstimate }} </span><br />
          <span class="priceShipping">{{ item.totalPrice * 1.05 | currency }}</span>
        </label>
      </div>
    }
    @if (listRate.data?.length >= 1) {
      <div class="form-check">
        <label class="form-check-label">
          <input type="radio" class="form-check-input" [value]="0" (change)="selectRate(0)" />
          Acordar con el vendedor<span class="dateShipping">- podrás recogerlo en un máximo de 72 hr o cuando se te confirme tu pedido en la tienda.</span><br />
        </label>
      </div>
    }
  }
</div>
